import axios from 'axios'

/**
 * 只读取某家门店的 get-venue 数据，**不经过** utils/request 的 requestMixin。
 *
 * 为什么不用 api/product.js 的 getVenue：requestMixin 的响应拦截把每个 get-venue 响应都当成「当前正在逛的店」——
 * `data.id !== store.state.venueId` 时会 resetState / resetAppState / resetCartState …，还会改时区、配送设置等。
 * 多店购物车要给成员店补拉附加费判定依据（utils/surchargeSnapshot.js ensureSubGroupSurchargeSources，
 * 附加费热修 Codex 第 2 轮 #3 / #4），拉的是**别家**店，走那条路会把顾客当前店的状态整个清掉。
 *
 * 这里只取数据：失败 / 后端 success = false 时返回 null，由调用方保留原快照；不弹窗、不校时钟、不写 store。
 * @param {string} id 门店 id
 * @returns {Promise<object|null>} get-venue 的 data
 */
const quietService = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  method: 'post',
  timeout: 15000
})

export function getVenueQuietly(id) {
  return quietService({ url: '/customer/default/get-venue', data: { id } })
    .then((res) => (res && res.data && res.data.success ? res.data.data : null))
    .catch(() => null)
}
